import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "./contexts/AuthContext";
import { CompanyProvider } from "./contexts/CompanyContext";
import { RoleProvider } from "./contexts/RoleContext";
import { TodoProvider } from "./contexts/TodoContext";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AuthProvider>
          <RoleProvider>
            <TodoProvider>
              <CompanyProvider>
                <AppRoutes />
              </CompanyProvider>
            </TodoProvider>
          </RoleProvider>
        </AuthProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
